export default __webpack_public_path__ + "static/media/bacqueville17.dd386e7c.jpg";